/* eslint-disable class-methods-use-this */
import { providesList } from '@helpers/providerList';
import BaseService from '../base';
import {
  DomainsApiProps, StoreParamsProps, StoreSectionApiProps, StoreSendEmailParamsProps,
} from './types';

class Domain extends BaseService {
  getStoresDomain() {
    return {
      query: ({ id, ...params }: StoreParamsProps) => ({
        url: `${this.url}/${id}/sections`,
        params,
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result?: DomainsApiProps) => providesList(result?.sections, 'Domains'),
    };
  }

  addDomain() {
    return {
      query: ({ id, ...body }: StoreSectionApiProps) => ({
        url: `${this.url}/${id}/sections`,
        method: 'POST',
        body,
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      invalidatesTags: [{ type: this.tagType }, { type: 'Section' }, { type: 'Domains' }],
    };
  }

  sendEmail() {
    return {
      query: ({ domainId, ...body }: StoreSendEmailParamsProps) => ({
        url: `/domains/${domainId}/sections/emails`,
        method: 'POST',
        body,
      }),
    };
  }
}

export default new Domain('domains', 'Domain');
